import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog'
import { useDeleteRecurring } from '@/lib/hooks'
import type { RecurringTransaction } from '@/lib/hooks'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  item: RecurringTransaction | null
}

export function DeleteRecurringDialog({ open, onOpenChange, item }: Props) {
  const deleteRec = useDeleteRecurring()

  const handleDelete = () => {
    if (!item) return
    deleteRec.mutate(item.id, {
      onSuccess: () => onOpenChange(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>固定支出を削除</DialogTitle>
          <DialogDescription>
            この固定支出テンプレートを削除しますか？過去に登録済みの取引は残ります。
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            キャンセル
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleteRec.isPending}
          >
            {deleteRec.isPending ? '削除中...' : '削除'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
